/* eslint-disable react/no-unused-prop-types */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider as ReduxProvider } from 'react-redux';
import reportToBigQuery from '../Utils/bigQueryReporter';
import { Provider as ModalProvider } from './providers/modal';
import { Provider as TranslationsProvider } from './providers/i18n';
import { createStore, createInitialState } from './store';
import Root from './Root';

import './style.scss';

class Previewer extends Component {
    constructor(props) {
        super(props);

        this.store = createStore(
            createInitialState(this.props),
            this.props
        );
    }

    componentDidMount() {
        const { source } = this.props;
        this.trackPageVisit(source);
    }

    trackPageVisit(source) {
        reportToBigQuery({
            type: 'collaboration_tool_show',
            group: 'page_view',
            collaboration: {
                source
            }
        });
    }

    render() {
        const {
            close,
            locale
        } = this.props;

        return (
            <ReduxProvider store={this.store}>
                <ModalProvider close={close}>
                    <TranslationsProvider locale={locale}>
                        <Root close={close}/>
                    </TranslationsProvider>
                </ModalProvider>
            </ReduxProvider>
        );
    }
}

Previewer.propTypes = {
    filerrIds: PropTypes.arrayOf(PropTypes.string),
    filerrs: PropTypes.array,
    currentFilerrId: PropTypes.string.isRequired,
    userId: PropTypes.number,
    collaboratorId: PropTypes.string,
    recipientIds: PropTypes.arrayOf(PropTypes.number),
    contextType: PropTypes.string,
    contextId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    withCollaboration: PropTypes.bool,
    withRevision: PropTypes.bool,
    withPostRevision: PropTypes.bool,
    reviewId: PropTypes.string,
    withModalBehavior: PropTypes.bool,
    withUnsubscribe: PropTypes.bool,
    source: PropTypes.string,
    callbacks: PropTypes.shape({
        onReviewCreated: PropTypes.func
    }),
    groupType: PropTypes.string,
    close: PropTypes.func,
    locale: PropTypes.string,
    requiredGroupType: PropTypes.string,
    teamId: PropTypes.string
};

Previewer.defaultProps = {
    withCollaboration: false,
    withRevision: false,
    withPostRevision: false,
    reviewId: '',
    withModalBehavior: true,
    filerrs: [],
    recipientIds: [],
    groupType: 'seller',
    requiredGroupType: 'seller'
};

export default Previewer;
